import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';
import AAF from "src/AAF/AAF";

class LevelGenericTask extends AbstractRequestTask {

    constructor(params) {
        super();
        this.params = params
        this.version = 'v2';
    }


    getUrl() {
        const http = "https://";
        const url = Launcher.get("akamai_mfwk");
        
        return `${http}${url}/services/cms/${this.version}/level`;
    }

    getParams() {

        const params = super.getParams();
        delete params.api_version;
        delete params.HKS;
        params.module_version = this.version;
        return Object.assign({}, params, this.params);
    }

    success(data, b) {
        this.resolve(data);
    }

    getShowErrorModal(){
        return ENABLE_MODAL_RETRIES;
    }
}

export default LevelGenericTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/cms/LevelGeneric.js